<template>
  <div>
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <span class="page-title">币安合约</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>划转记录</el-breadcrumb-item>
    </el-breadcrumb>

    <el-form style="float: left; width: 100%; margin-top: 20px">
      <el-form-item style="display: inline-block; margin-right: 10px">
        <el-input
          v-model="queryParams.id"
          placeholder="记录ID"
          style="width: 300px"
        ></el-input>
      </el-form-item>
      <el-form-item style="display: inline-block; margin-right: 10px">
        <el-input
          v-model="queryParams.userId"
          placeholder="用户ID"
          style="width: 300px"
        ></el-input>
      </el-form-item>
      <el-form-item style="display: inline-block; margin-right: 10px">
        <el-input
          v-model="queryParams.coinType"
          placeholder="币种"
          style="width: 200px"
        ></el-input>
      </el-form-item>
      <el-form-item style="display: inline-block; margin-right: 10px">
        <el-select v-model="queryParams.type">
          <el-option value="" label="全部"></el-option>
          <el-option value="-1" label="转出"></el-option>
          <el-option value="1" label="转入"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item style="display: inline-block; margin-right: 10px">
        <el-select v-model="queryParams.status">
          <el-option value="" label="全部"></el-option>
          <el-option value="0" label="创建"></el-option>
          <el-option value="1" label="内部转账成功"></el-option>
          <el-option value="-1" label="内部转账失败"></el-option>
          <el-option value="2" label="外部转账成功"></el-option>
          <el-option value="-2" label="外部转账失败"></el-option>
          <el-option value="3" label="成功"></el-option>
          <el-option value="-3" label="失败"></el-option>
          <el-option value="-4" label="未知"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item style="display: inline-block; margin-right: 10px">
        <el-date-picker
          v-model="timeArr"
          type="datetimerange"
          value-format="timestamp"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </el-form-item>
      <el-button type="primary" @click="getContractTransferList"
        >搜 索</el-button
      >
      <el-button type="primary" @click="forceTransfer">强制划转</el-button>
      <el-button type="primary" @click="transferExport">导 出</el-button>
      <span style="color: red; padding-left: 20px"
        >导出的数据尽量不要超过10000条</span
      >
    </el-form>

    <el-table
      border
      :header-cell-style="{ background: '#FFF5F4', color: '#EC6D56' }"
      style="margin-top: 20px"
      :data="dataList"
      :row-key="() => Math.random()"
    >
      <el-table-column
        prop="userId"
        label="用户ID"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="coinType"
        label="币种"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="txnId"
        label="txnId"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="amount"
        label="划转量"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="type"
        label="子账户转入/转出"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span v-if="scope.row.type == -1">转出</span>
          <span v-if="scope.row.type == 1">转入</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="executeTimes"
        label="执行次数"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column prop="status" label="状态" show-overflow-tooltip>
        <template slot-scope="scope">
          <span v-if="scope.row.status == 0">创建</span>
          <span v-if="scope.row.status == -1">内部转账失败</span>
          <span v-if="scope.row.status == 1">内部转账成功</span>
          <span v-if="scope.row.status == -2">外部转账失败</span>
          <span v-if="scope.row.status == 2">外部转账成功</span>
          <span v-if="scope.row.status == -3">失败</span>
          <span v-if="scope.row.status == 3">成功</span>
          <span v-if="scope.row.status == -4">未知</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="remark"
        label="备注"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column label="最后一次执行时间">
        <template slot-scope="scope">
          <span>{{ scope.row.lastExecuteTime | moment }}</span>
        </template>
      </el-table-column>
      <el-table-column label="更新时间">
        <template slot-scope="scope">
          <span>{{ scope.row.updateTime | moment }}</span>
        </template>
      </el-table-column>
      <el-table-column label="创建时间">
        <template slot-scope="scope">
          <span>{{ scope.row.createTime | moment }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" fixed="right" width="420px">
        <template slot-scope="scope">
          <el-button
            type="danger"
            @click="transferRetryDialog(scope.row.id)"
            :disabled="
              !(
                scope.row.status == 0 ||
                scope.row.status == 1 ||
                scope.row.status == -2 ||
                scope.row.status == 2
              )
            "
          >
            重试
          </el-button>
          <el-button
            type="danger"
            @click="updateRecordId(scope.row.id)"
            :disabled="!(scope.row.status == -2 && scope.row.txnId != null)"
            >修改ID
          </el-button>
          <el-button
            type="primary"
            @click="seeContractBinanceTransfer(scope.row.id)"
            >币安记录</el-button
          >
          <el-button
            type="primary"
            @click="seeUniversalTransferRecord(scope.row.id)"
            >币客记录</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      style="margin-top: 30px"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="queryParams.page"
      :page-sizes="[10, 50, 100, 200, 500]"
      :page-size="queryParams.size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    >
    </el-pagination>

    <el-dialog
      :visible.sync="retryDialogVisible"
      title="提示"
      width="400px"
      @close="clearData"
    >
      <div class="action" style="text-align: left">
        <span>确认重试吗？</span>
        <el-checkbox v-model="forceRetry" style="padding-left: 50px; color: red"
          >是否强制重试</el-checkbox
        >
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="retryDialogVisible = false"
          >取 消</el-button
        >
        <el-button
          size="small"
          type="primary"
          :loading="loading"
          @click="transferRetry"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <el-dialog
      :visible.sync="bkDialogVisible"
      title="币客划转详情"
      width="1200px"
      @close="clearDataOne"
    >
      <el-form style="width: 100%" inline>
        <el-form-item label="ID：" style="margin-right: 10px; width: 350px">
          <span>{{ bkTransferDetail.id }}</span>
        </el-form-item>
        <el-form-item label="用户ID：" style="margin-right: 10px; width: 350px">
          <span>{{ bkTransferDetail.userId }}</span>
        </el-form-item>
        <el-form-item
          label="币安子账户ID："
          style="margin-right: 10px; width: 350px"
        >
          <span>{{ bkTransferDetail.binanceSubUserAccountId }}</span>
        </el-form-item>
        <el-form-item label="币种：" style="margin-right: 10px; width: 350px">
          <span>{{ bkTransferDetail.coinType }}</span>
        </el-form-item>
        <el-form-item label="txnId：" style="margin-right: 10px; width: 350px">
          <span>{{ bkTransferDetail.txnId }}</span>
        </el-form-item>
        <el-form-item label="划转量：" style="margin-right: 10px; width: 350px">
          <span>{{ bkTransferDetail.amount }}</span>
        </el-form-item>
        <el-form-item
          label="子账户转入/转出："
          style="margin-right: 10px; width: 350px"
        >
          <span v-if="bkTransferDetail.type == -1">转出</span>
          <span v-if="bkTransferDetail.type == 1">转入</span>
        </el-form-item>
        <el-form-item
          label="执行次数："
          style="margin-right: 10px; width: 350px"
        >
          <span>{{ bkTransferDetail.executeTimes }}</span>
        </el-form-item>
        <el-form-item label="状态：" style="margin-right: 10px; width: 350px">
          <span v-if="bkTransferDetail.status == 0">创建</span>
          <span v-if="bkTransferDetail.status == -1">内部转账失败</span>
          <span v-if="bkTransferDetail.status == 1">内部转账成功</span>
          <span v-if="bkTransferDetail.status == -2">外部转账失败</span>
          <span v-if="bkTransferDetail.status == 2">外部转账成功</span>
          <span v-if="bkTransferDetail.status == -3">失败</span>
          <span v-if="bkTransferDetail.status == 3">成功</span>
          <span v-if="bkTransferDetail.status == -4">未知</span>
        </el-form-item>
        <el-form-item
          label="最后一次执行时间："
          style="margin-right: 10px; width: 350px"
        >
          <span>{{ bkTransferDetail.lastExecuteTime | moment }}</span>
        </el-form-item>
        <el-form-item
          label="更新时间："
          style="margin-right: 10px; width: 350px"
        >
          <span>{{ bkTransferDetail.updateTime | moment }}</span>
        </el-form-item>
        <el-form-item
          label="创建时间："
          style="margin-right: 10px; width: 350px"
        >
          <span>{{ bkTransferDetail.createTime | moment }}</span>
        </el-form-item>
        <el-form-item label="备注：" style="margin-right: 10px; width: 100%">
          <span>{{ bkTransferDetail.remark }}</span>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button type="danger" @click="bkDialogVisible == false"
          >关 闭</el-button
        >
      </span>
    </el-dialog>

    <el-dialog
      :visible.sync="baDialogVisible"
      title="币安划转详情"
      width="1200px"
      @close="clearDataOne"
    >
      <el-form style="width: 100%" inline>
        <el-form-item
          label="转入账户ID："
          style="margin-right: 10px; width: 350px"
        >
          <span>{{ baTransferDetail.toId }}</span>
        </el-form-item>
        <el-form-item
          label="转出账户ID："
          style="margin-right: 10px; width: 350px"
        >
          <span>{{ baTransferDetail.fromId }}</span>
        </el-form-item>
        <el-form-item label="币种：" style="margin-right: 10px; width: 350px">
          <span>{{ baTransferDetail.asset }}</span>
        </el-form-item>
        <el-form-item label="数量：" style="margin-right: 10px; width: 350px">
          <span>{{ baTransferDetail.qty }}</span>
        </el-form-item>
        <el-form-item label="时间：" style="margin-right: 10px; width: 350px">
          <span>{{ baTransferDetail.time | moment }}</span>
        </el-form-item>
        <el-form-item label="txnId：" style="margin-right: 10px; width: 350px">
          <span>{{ baTransferDetail.txnId }}</span>
        </el-form-item>
        <el-form-item
          label="平台划转ID："
          style="margin-right: 10px; width: 350px"
        >
          <span>{{ baTransferDetail.clientTranId }}</span>
        </el-form-item>
        <el-form-item
          label="转出账户类型："
          style="margin-right: 10px; width: 350px"
        >
          <span>{{ baTransferDetail.fromAccountType }}</span>
        </el-form-item>
        <el-form-item
          label="转入账户类型："
          style="margin-right: 10px; width: 350px"
        >
          <span>{{ baTransferDetail.toAccountType }}</span>
        </el-form-item>
        <el-form-item label="状态：" style="margin-right: 10px; width: 350px">
          <span>{{ baTransferDetail.status }}</span>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button type="danger" @click="baDialogVisible == false"
          >关 闭</el-button
        >
      </span>
    </el-dialog>
    <force-transfer
      :isShow="isShow"
      v-if="isShow"
      @handleClose="handleClose"
    ></force-transfer>
  </div>
</template>

<script>
import "../store";
import api from "../api";
import ForceTransfer from "../forceTransfer";

export default {
  name: "TransferRecord",
  components: {
    ForceTransfer,
  },
  data() {
    return {
      isShow: false,
      dataList: [],
      total: 0,
      queryParams: {
        userId: "",
        coinType: "",
        type: "",
        status: "",
        transferCreateBeginTime: "",
        transferCreateEndTime: "",
        page: 1,
        size: 10,
      },
      forceRetry: false,
      retryDialogVisible: false,
      currId: -1,
      loading: false,
      bkDialogVisible: false,
      baDialogVisible: false,
      bkTransferDetail: {},
      baTransferDetail: {},
      timeArr: [],
    };
  },
  methods: {
    forceTransfer() {
      this.isShow = true;
    },
    handleClose() {
      this.isShow = false;
    },
    getContractTransferList() {
      if (this.timeArr != null) {
        this.queryParams.transferCreateBeginTime =
          this.timeArr[0] == undefined ? "" : this.timeArr[0];
        this.queryParams.transferCreateEndTime =
          this.timeArr[1] == undefined ? "" : this.timeArr[1];
      } else {
        this.queryParams.transferCreateEndTime == "";
        this.queryParams.transferCreateBeginTime == "";
      }

      api.getContractTransferList(this.queryParams).then(({ data }) => {
        this.dataList = data.records;
        this.total = data.total;
      });
    },
    handleSizeChange(val) {
      this.queryParams.size = val;
      this.getContractTransferList();
    },
    handleCurrentChange(val) {
      this.queryParams.page = val;
      this.getContractTransferList();
    },
    transferRetryDialog(id) {
      this.currId = id;
      this.retryDialogVisible = true;
    },
    updateRecordId(id) {
      this.$confirm("此操作须谨慎，确认修改吗？", "提示", {
        type: "warning",
      })
        .then(() => {
          api.updateRecordId({ id: id }).then(({ data }) => {
            this.$message.success("修改成功！");
            this.getContractTransferList();
          });
        })
        .catch(() => {});
    },
    transferRetry() {
      this.loading = true;
      api
        .transferRetry({ id: this.currId, forceRetry: this.forceRetry })
        .then(({ req }) => {
          this.loading = false;
          this.retryDialogVisible = false;
          this.$message.success("操作成功！");
        });
    },
    seeContractBinanceTransfer(id) {
      api.getContractBinanceTransfer({ id: id }).then(({ data }) => {
        if (data) {
          this.baTransferDetail = data;
          this.baDialogVisible = true;
        } else {
          this.$message.success("暂无记录！");
        }
      });
    },
    seeUniversalTransferRecord(id) {
      api.getUniversalTransferRecord({ id: id }).then(({ data }) => {
        if (data) {
          this.bkTransferDetail = data;
          this.bkDialogVisible = true;
        } else {
          this.$message.success("暂无记录！");
        }
      });
    },
    transferExport() {
      if (this.timeArr != null) {
        this.queryParams.transferCreateBeginTime = this.timeArr[0];
        this.queryParams.transferCreateEndTime = this.timeArr[1];
      } else {
        this.queryParams.transferCreateEndTime == "";
        this.queryParams.transferCreateBeginTime == "";
      }

      if (
        this.queryParams.transferCreateEndTime == "" ||
        this.queryParams.transferCreateBeginTime == "" ||
        this.queryParams.transferCreateEndTime == undefined ||
        this.queryParams.transferCreateBeginTime == undefined
      ) {
        this.$message.error("请选择时间范围！");
        return;
      }
      api.transferExport(this.queryParams).then((response) => {
        const fileName =
          "划转记录导出数据表" +
          this.queryParams.transferCreateBeginTime +
          "-" +
          this.queryParams.transferCreateEndTime +
          ".xlsx";
        const blob = new Blob([response], { type: "application/vnd.ms-excel" });
        if ("download" in document.createElement("a")) {
          const link = document.createElement("a");
          link.download = fileName;
          link.style.display = "none";
          link.href = URL.createObjectURL(blob);
          document.body.appendChild(link);
          link.click();
          URL.revokeObjectURL(link.href);
        } else {
          navigator.msSaveBlob(blob, fileName);
        }
      });
    },
    clearData() {
      this.loading = false;
      this.forceRetry = false;
      this.currId = -1;
    },
    clearDataOne() {
      this.bkTransferDetail = {};
      this.baTransferDetail = {};
    },
  },
  created() {
    // this.getContractTransferList();
  },
};
</script>

<style lang="less" scoped>
</style>

